import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Right, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RightService {

  constructor(private httpClient: HttpClient) { }

  getRights(): Observable<Response<Right[]>> {
    return this.httpClient.get<Response<Right[]>>(environment.apiPath + 'Right');
  }

  getRightsByUserId(id: number): Observable<Response<Right[]>> {
    return this.httpClient.get<Response<Right[]>>(environment.apiPath + 'Right/' + id + '/UserId');
  }
}
